import { AfterViewInit, Component, ElementRef, Input } from '@angular/core';

@Component({
  selector: 'screen-cell-bordered,screen-cell[bordered]',
  templateUrl: './cell.bordered.component.html',
  styleUrls: ['./cell.bordered.component.less']
})
export class CellBorderedComponent implements AfterViewInit {

  @Input()
  center = false;

  @Input()
  innerPadding = null;

  @Input()
  diagonal = false;

  constructor(private _elementRef: ElementRef) {
  }

  ngAfterViewInit() {
  }
}
